import React, { Component } from "react";
import ReportBadge from "./ReportBadge";

export default class ReportOveral extends Component {
  render() {
    // `eyebrow`, `number` and `id` are used by the V2 report; V1 passes none of
    // them and renders exactly as before.
    const { eyebrow, id, number } = this.props;

    return (
      <div className="report__page__wrapper" id={id || "page-result"}>
        <div
          className={`report__page report_page--split_11${
            number !== undefined ? " report__page--numbered" : ""
          }`}
        >
          <div className="report__info report__section--padding">
            {eyebrow && <p className="report-v2__eyebrow">{eyebrow}</p>}
            <h2>{this.props.title}</h2>
            <h3>{this.props.subtitle}</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.description }} />
          </div>
          <div
            className="report__chart"
            style={{
              alignItems: "flex-start",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {this.props.children}
          </div>
          {number !== undefined && (
            <span className="report-v2__page-number">{number}</span>
          )}
        </div>
        {number === undefined && <ReportBadge />}
      </div>
    );
  }
}
